import axios, { AxiosResponse } from "axios";
import { ShowPopupError } from "../../components/error-popup";
import { HideSpinner, ShowSpinner } from "../../components/spinner";
import { IFormError } from "../../models/error/form-error";

const priceDescription: NodeListOf<HTMLElement> = document.querySelectorAll(".price_description");
const radioButtons: NodeListOf<HTMLInputElement> = document.querySelectorAll(
	".check__radio.desktop"
);
const radioButtonsMobile: NodeListOf<HTMLInputElement> = document.querySelectorAll(
	".check__radio.mobile"
);
const eventBoxes: NodeListOf<HTMLElement> = document.querySelectorAll(
	".box--grey.acc.desktop button"
);
const eventBoxesMobile: NodeListOf<HTMLElement> = document.querySelectorAll(
	".box--grey.acc.mobile button"
);
const bookButtons: NodeListOf<HTMLElement> = document.querySelectorAll(".cart__btn");

function ShowPriceDescription(ev: MouseEvent): void {
	for (let i = 0, length = radioButtons.length; i < length; i++) {
		if (radioButtons[i].checked && ev.currentTarget === radioButtons[i]) {
			priceDescription.forEach(function(el) {
				if (radioButtons[i].dataset.descriptiontext !== "") {
					el.innerHTML = `* ${radioButtons[i].dataset.descriptiontext}`;
				} else {
					el.innerHTML = "";
				}
			});
			break;
		}
	}
}

function ShowPriceDescriptionMobile(ev: MouseEvent): void {
	for (let i = 0, length = radioButtonsMobile.length; i < length; i++) {
		if (radioButtonsMobile[i].checked && ev.currentTarget === radioButtonsMobile[i]) {
			priceDescription.forEach(function(el) {
				if (radioButtons[i].dataset.descriptiontext !== "") {
					el.innerHTML = `* ${radioButtons[i].dataset.descriptiontext}`;
				} else {
					el.innerHTML = "";
				}
			});
			break;
		}
	}
}

function OpenEventBox(this: HTMLElement): void {
	const activeEventBox: HTMLElement = document.querySelector(".box--grey.acc.desktop.open");
	const parentContainer = this.parentElement.parentElement as HTMLElement;
	if (parentContainer !== activeEventBox) {
		activeEventBox.classList.remove("open");
		parentContainer.classList.add("open");
		activeEventBox.querySelector("button").setAttribute("aria-expanded", "false");
		this.setAttribute("aria-expanded", "true");
	}
}

function OpenEventBoxMobile(this: HTMLElement): void {
	const activeEventBox: HTMLElement = document.querySelector(".box--grey.acc.mobile.open");
	const parentContainer = this.parentElement.parentElement as HTMLElement;
	if (this !== activeEventBox) {
		activeEventBox.classList.remove("open");
		parentContainer.classList.add("open");
		activeEventBox.querySelector("button").setAttribute("aria-expanded", "false");
		this.setAttribute("aria-expanded", "true");
	}
}

function AddToCart(this: HTMLElement): void {
	ShowSpinner();

	const box = this.parentElement.parentElement as HTMLElement;
	const selectedRadioButton = box.querySelector(".check__radio:checked") as HTMLInputElement;
	const engId = this.getAttribute("data-engagementId");
	const prodId = this.getAttribute("data-productId");
	const priceTypeId = selectedRadioButton?.getAttribute("data-priceTypeId");

	const data = { engId: engId, prodId: prodId, priceTypeId: priceTypeId };

	axios
		.post(`/umbraco/api/lineItem/Add`, data)
		.then((result: AxiosResponse) => {
			HideSpinner();
			window.location.href = "/warenkorb";
		})
		.catch((error: any) => {
			if (error?.response?.data) {
				const object = error?.response?.data as IFormError;
				if (object.ErrorMessage) {
					ShowPopupError(object.ErrorMessage);
				}
			}
			HideSpinner();
			console.error(error);
		});
}

export const ShowPricesInfo = (): void => {
	radioButtons.forEach(function(button) {
		if (button.checked && button.dataset.descriptiontext !== "") {
			button.parentElement.parentElement.querySelector(
				".price_description"
			).innerHTML = `* ${button.dataset.descriptiontext}`;
		}
		button.addEventListener("click", ShowPriceDescription);
	});

	radioButtonsMobile.forEach(function(buttonMobile) {
		if (buttonMobile.checked && buttonMobile.dataset.descriptiontext !== "") {
			buttonMobile.parentElement.parentElement.querySelector(
				".price_description"
			).innerHTML = `* ${buttonMobile.dataset.descriptiontext}`;
		}
		buttonMobile.addEventListener("click", ShowPriceDescriptionMobile);
	});
};

export const ToggleEventBoxes = (): void => {
	eventBoxes.forEach(function(eventBox) {
		eventBox.addEventListener("click", OpenEventBox);
	});

	eventBoxesMobile.forEach(function(eventBoxMobile) {
		eventBoxMobile.addEventListener("click", OpenEventBoxMobile);
	});
};
export const ClickAddToCartButton = (): void => {
	bookButtons.forEach(function(bookBtn) {
		bookBtn.addEventListener("click", AddToCart);
	});
};
